var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "excursion" },
    _vm._l(
      _setup.props.timetable,
      function ({ daystops, dayrec: { start, nday } }) {
        return _c(
          "div",
          { key: nday, staticClass: "excursion__element" },
          [
            _c(
              "div",
              {
                staticClass: "excursion__header",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _setup.day_click(nday)
                  },
                },
              },
              [
                _c("div", { staticClass: "excursion__title" }, [
                  _vm._v("День " + _vm._s(nday)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "excursion__date" }, [
                  _vm._v(
                    _vm._s(start.locale("ru").format("D MMMM YYYY, dddd"))
                  ),
                ]),
                _vm._v(" "),
                _c(_setup.vDown, {
                  staticClass: "vicon-white excursion__expand",
                  class: { _open: _setup.opened_has(nday) },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _setup.opened_has(nday)
              ? [
                  _c(
                    "div",
                    { staticClass: "excursion__content" },
                    _vm._l(daystops, function (day) {
                      return _c(
                        "div",
                        { key: day.id, staticClass: "excursion__point" },
                        [
                          _c("div", { staticClass: "excursion__brief" }, [
                            _c(
                              "div",
                              { staticClass: "excursion__brief-title" },
                              [_vm._v(_vm._s(day.place))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "excursion__brief-section" },
                              [
                                day.hasArrival
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "excursion__brief-element",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "excursion__brief-label",
                                          },
                                          [_vm._v("Прибытие")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "excursion__brief-value",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_setup.arrival(day, nday))
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                day.hasArrival && day.hasDeparture
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "excursion__brief-element",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "excursion__brief-label",
                                          },
                                          [_vm._v("Стоянка")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "excursion__brief-value",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_setup.diff(day, nday))
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                day.hasDeparture
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "excursion__brief-element",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "excursion__brief-label",
                                          },
                                          [_vm._v("Отправление")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "excursion__brief-value",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _setup.departure(day, nday)
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(_setup.InsertHtml, {
                            staticClass: "excursion__more",
                            attrs: { html: day.description, link: "pdf" },
                          }),
                          _vm._v(" "),
                          day.excursions
                            ? _c(_setup.MySliderExcursion, {
                                staticClass: "excursion__slider",
                                attrs: { excursion: day.excursions },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]
              : _vm._e(),
          ],
          2
        )
      }
    ),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }